export default __webpack_public_path__ + "static/media/carousel-img-two.67c1c164.png";